import { ChangeDetectionStrategy, Component, OnInit, inject, input, signal } from '@angular/core';
import { finalize } from 'rxjs';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MeasurementsService, DevicesService } from '@cosmos/angular/api';
import { Measurement, User } from '@cosmos/shared';
import { ErrorService, PanelService } from '@cosmos/angular/utils';
import { ButtonModule } from 'primeng/button';
import { DynamicFormV2Component } from '../../dynamic-form/dynamic-form.component';
import { EditMeasurementForm, MeasurementForm } from '../../dynamic-form/forms/measurement.form';

@Component({
  selector: 'cosmos-shm-edit-panel',
  imports: [TranslateModule, ButtonModule, DynamicFormV2Component],
  templateUrl: './shm-edit-panel.component.html',
  styleUrls: ['./shm-edit-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SHMEditPanelComponent implements OnInit {
  private readonly measurementsService = inject(MeasurementsService);
  private readonly devicesService = inject(DevicesService);
  private readonly errorService = inject(ErrorService);
  private readonly translateService = inject(TranslateService);
  private readonly panelService = inject(PanelService);

  readonly measurement = input.required<Measurement>();
  readonly user = input.required<User>();

  readonly form = signal<any>(null);
  readonly measurementModel = signal<any>({});
  readonly loading = signal(false);

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    const m = this.measurement();
    // The channel geometry selects (bar diameter / length) are sourced from the
    // device's DeviceProfile, so fetch it before building the form.
    const device = m.device as unknown as { _id: string } | string;
    const deviceId = typeof device === 'string' ? device : device?._id;
    this.devicesService.findById(deviceId, '?populate_deviceProfile=class,parameters').subscribe({
      next: (response) => {
        const editForm = new EditMeasurementForm(this.translateService, m, this.user(), {
          measurementType: 'StructuralHealthMeasurement',
          deviceProfile: response.body?.deviceProfile,
        });
        this.form.set(editForm);
        this.measurementModel.set(editForm.model);
      },
      error: (e) => this.errorService.handleError(e)
    });
  }

  save(event: any) {
    this.loading.set(true);
    let updateData = event;
    updateData = MeasurementForm.transformArrayToMap(updateData);

    this.measurementsService.update([this.measurement()._id, updateData]).pipe(
      finalize(() => this.loading.set(false)),
    ).subscribe(
      this.errorService.handleMutation({
        successMessageKey: 'measurement.messages.updateSuccess',
        onSuccess: () => this.panelService.close(),
      }),
    );
  }

  cancel() {
    this.panelService.close();
  }
}
